<template>
  <div id="app">
    <!-- 主内容区域 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>

    <!-- <router-view /> -->

    <!-- 全局底部导航 -->
    <!-- <van-tabbar v-model="activeTab" v-show="showTabbar" fixed route>
      <van-tabbar-item 
        v-for="(item, index) in tabbarList" 
        :key="index"
        :name="item.name" 
        :icon="item.icon"
        :to="item.path"
        :dot="item.dot"
        :info="item.info"
      >
        {{ item.text }}
      </van-tabbar-item>
    </van-tabbar> -->
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      activeTab: "home",
      tabbarList: [
        {
          name: "home",
          path: "/",
          icon: "home-o",
          text: "首页",
        },
        {
          name: "category",
          path: "/category",
          icon: "apps-o",
          text: "分类",
        },
        {
          name: "cart",
          path: "/cart",
          icon: "shopping-cart-o",
          text: "购物车",
          info: "3",
        },
        {
          name: "profile",
          path: "/profile",
          icon: "user-o",
          text: "我的",
        },
      ],
    };
  },
  computed: {
    showTabbar() {
      // 在这些页面隐藏底部导航
      const hiddenPaths = ["/login", "/detail"];
      return !hiddenPaths.includes(this.$route.path);
    },
  },
  watch: {
    $route(to) {
      // 路由变化时更新激活的标签
      const route = this.tabbarList.find((item) => item.path === to.path);
      if (route) {
        this.activeTab = route.name;
      }
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: "PingFang SC", "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  background: #f7f8fa;
  min-height: 100vh;
}

/* 全局样式 */
.page-container {
  padding-bottom: 50px;
  min-height: 100vh;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  padding: 15px;
}

.divider {
  height: 8px;
  background: #f7f8fa;
}
</style>